import { Flex, Typography } from "@qws-org/ui-kit";
import type { FC } from "react";
import { useId } from "react-aria";

import { RatingStar } from "./RatingStar";

type StartsBlockProps = { rating: number; maxScore?: number };

export const RatingBlock: FC<StartsBlockProps> = ({ rating, maxScore = 5 }) => {
  const fullStarsCount = Math.floor(rating);
  const fillPercentage = (rating - fullStarsCount) * 100;

  return (
    <Flex
      flexDirection="column"
      justify={"center"}
      align={"center"}
      m={{ mb: 24 }}
      md={{ m: { mb: 32 } }}
    >
      <Typography
        size="large"
        color="text-accent-default"
        fontWeight="mobile.bold"
        m={{ mt: 32, mb: 8 }}
      >
        {Number.isInteger(rating) ? rating : rating.toFixed(1)}/ {maxScore}
      </Typography>
      <Flex
        gap={8}
        m={{ mx: "auto" }}
        width="auto"
        justify="center"
        align="center"
      >
        {Array(maxScore)
          .fill(null)
          .map((_, index) => {
            let starFill = 0;

            if (index < fullStarsCount) {
              starFill = 100;
            }
            if (index === fullStarsCount && fillPercentage > 0) {
              starFill = fillPercentage;
            }

            return (
              <RatingStar
                key={index}
                fillPercentage={starFill}
                className={
                  index < fullStarsCount
                    ? "drop-shadow-[0px_0px_6px_var(--colors-text-accent-default)]"
                    : ""
                }
                clipPathId={useId()}
              />
            );
          })}
      </Flex>
    </Flex>
  );
};
